import StaffAttendanceQueries from './StaffAttendanceQueries.js'

const staffAttendance = {
  staffAttendance: {
    ...StaffAttendanceQueries,
  }
}

export default staffAttendance